import type { FilterContentProps } from './WalletDetailsFilter.types';
import type { ReactElement } from 'react';

import { CheckboxCards, Flex, ScrollArea, Text } from '@rango-dev/whale';
import { useWallets } from '@rango-dev/widget-embedded';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import { useWalletDetails } from '../../../hooks/useWalletDetails';
import { setExcludedWallets } from '../../../state/WalletDetailsSlice';
import { containsText } from '../../../utils/generalFunctions/common';

import { WalletDetailFilterHeader } from './WalletDetailFilterHeader';
import styles from './WalletDetailsFilter.module.css';

const SYMBOL_SIZE = 32;

export function ConnectedWalletFilter(props: FilterContentProps): ReactElement {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { toggleExcludedAllWallet, connectedWallets } = useWalletDetails();
  const [searchedFor, setSearchedFor] = useState<string>('');
  const { getWalletInfo } = useWallets();

  const { excludedWallets } = useAppSelector((state) => state.walletDetails);

  const originalConnectWallet = connectedWallets.map((walletItem) => {
    const walletInfo = getWalletInfo(walletItem);
    return { walletType: walletItem, ...walletInfo };
  });

  let filteredList = originalConnectWallet;
  if (searchedFor) {
    filteredList = originalConnectWallet.filter((walletItem) =>
      containsText(walletItem.name, searchedFor),
    );
  }

  const selectedWallets = connectedWallets.filter(
    (walletItem) => !excludedWallets.includes(walletItem),
  );

  const handleValueChange = (nextSelected: string[]) => {
    dispatch(
      setExcludedWallets(
        connectedWallets.filter((walletItem) => !nextSelected.includes(walletItem)),
      ),
    );
  };

  return (
    <WalletDetailFilterHeader
      title={t('Your Wallets')}
      showHeader={props.showHeader}
      handleToggleAll={toggleExcludedAllWallet}
      excludedItems={excludedWallets}
      searchHandler={setSearchedFor}
      searchedFor={searchedFor}
      searchInputId="wallet-details-wallet-filter-search-input"
      toggleButtonId="wallet-details-wallet-filter-toggle-all-btn"
    >
      <ScrollArea type="auto" scrollbars="vertical" className={styles.list}>
        <CheckboxCards.Root
          size="1"
          columns="1"
          gap="2"
          value={selectedWallets}
          onValueChange={handleValueChange}
        >
          {filteredList.map((walletItem) => (
            <CheckboxCards.Item key={walletItem.walletType} value={walletItem.walletType}>
              <Flex align="center" gap="2" flexGrow="1" minWidth="0">
                <img
                  className={styles.symbol}
                  src={walletItem.img}
                  alt={walletItem.name}
                  width={SYMBOL_SIZE}
                  height={SYMBOL_SIZE}
                />
                <Text size="2" weight="medium" truncate>
                  {walletItem.name}
                </Text>
              </Flex>
            </CheckboxCards.Item>
          ))}
        </CheckboxCards.Root>
      </ScrollArea>
    </WalletDetailFilterHeader>
  );
}
